<template>
  <div class="flex center history-page" >
    <div class="filter_container">
      <v-tabs v-model="status" @change="onTabChange">
        <v-tab
          v-for="item in statusTabs"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>

      <div class="filter_content">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="10"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="shrink mr-2 mt-3" style="width:180px; height:45px;"
                id="fr_date" 
                ref="fr_date" 
                v-model="fr_date"
                label="부터"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="fr_date"
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="10"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense outlined clearable class="shrink mr-2  mt-3"  style="width:180px; height:45px;"
                id="to_date" 
                ref="to_date" 
                v-model="to_date"
                label="까지"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title locale="ko-KR"
              v-model="to_date"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>

        <!-- </div> -->

        <v-autocomplete dense outlined 
          class="shrink mr-2 mt-3"
          style="width:180px; height:45px;"
          id="as_item" 
          v-model="as_item" 
          ref="as_item" 
          label="A/S 항목"
          :items="asItems"
          item-text="name"
          :menu-props="{ top: false, offsetY: true }"
          return-object
        />
        <v-autocomplete dense outlined
          id="farm" 
          ref="farm" 
          class="shrink mr-2 mt-3"
          style="width:180px; height:45px;"
          label="사업장명*"
          v-model="farm"
          :items="farmItems"
          :menu-props="{ top: false, offsetY: true }"
          no-data-text="자료(권한)이 없습니다."
          item-text="name"
          return-object
          @focus="comboFarms()"
          clearable
          />

        <v-btn class="serach_btn" @click="history()" :loading="loading">
          <v-icon color="#2D3748">mdi-refresh</v-icon>
        </v-btn>
      </div>

      <div class="mt-3 history__layout">
        <v-data-table 
          dense height="65vh"
          class="table"
          fixed-header
          hide-default-footer
          :items-per-page="-1" 
          :group-by="['farm.code']"
          :loading="loading"
          :headers="headers"
          :items="items"
          no-data-text="등록된 A/S가 없거나 접근 권한이 없습니다."
          @click:row="infoAs"
          item-key="regdate"
          single-select
        >
        <template v-slot:group.header="{items, isOpen, toggle}">
            <th colspan="6" style="text-align: left !important;">
              <v-icon @click="toggle">
              {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> 
              <span>{{ items[0].farm.name }} </span>
            </th>
          </template>
          <template v-slot:item="{ item }">
            <tr @click="infoAs(item)" :style="select && select.register_no === item.register_no ? 'background-color: #f1f5f9 !important; ' : ''">
              <td>{{ item.regdate }}</td>
              <td>{{ item.register_no }}</td>

              <td>{{ item.division1.description }}</td>
              <td>{{ item.reguser.name }}</td>
              <td>{{ statusText(item.process_status.code) }}</td>
              <td style="text-align:right; cursor:pointer;" @click="infoAs(item)">
                <v-icon>mdi-chevron-right</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <div class="manage_container" v-if="info && info.farm" >
     <div class="tab_container">
      <div class="tab_content">
        <button class="tab mr-1" 
          :class="{ active: selectedTab === '접수응대' }" 
          @click="selectTab('접수응대')">
          접수내용 및 응답
        </button>

        <!-- <button class="tab mr-1" 
          :class="{ active: selectedTab === '고객응대' }" 
          @click="selectTab('고객응대')">
          접수내용 및 응답
        </button> -->

        <button class="tab mr-1" 
          :class="{ active: selectedTab === '조치내역' }" 
          @click="selectTab('조치내역')">
          조치내역
        </button>

        <button class="tab mr-1" 
          :class="{ active: selectedTab === '완료처리' }" 
          @click="selectTab('완료처리')">
          완료처리
        </button>
      </div>
     </div>

      <div class="title_container">
        <h3>{{ info.farm.name }} | {{ register_no }}</h3>
      </div>

      <div class="line"></div>
      <!-- {{ info }} -->

      <div class="content_container">
        <div v-show="selectedTab === '접수응대' " class="customer_container">
          
          <div class="flex">
            <div class="as_title"> 고객명</div>
            <div> {{info.reguser.name}} {{info.phone}}</div>
          </div>

          <div class="flex" style="margin-top:-10px;">
            <div class="as_title"> </div>
            <div class="lg_gray" v-show="info.contactable_time !== null"> 통화가능시간 : {{info.contactable_time}}</div>
          </div>

          <div class="flex">
            <div class="as_title"> A/S 항목</div>
            <div> {{info.division1.description}}</div>
          </div>

          <div class="flex">
            <div class="as_title"> 접수제목</div>
            <div> {{info.title}}</div>
          </div>

          <div v-show="info.contents !== null">
            <div class="flex">
              <div class="as_title">접수내용</div>
            </div>

            <div class="flex client_content">
              {{info.contents }}
            </div>
          </div>
        
          <div class="line"></div>

          <div class="flex a-center">
            <div class="as_title"> A/S 예정일자</div>
            <v-menu
              v-model="menu3"
              :close-on-content-click="false"
              :nudge-right="10"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable class="shrink mr-2  mt-3"  style="width:180px; height:45px;"
                  id="expected_date" 
                  ref="expected_date" 
                  v-model="expected_date"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="expected_date"
                @change="dateChange"  
                @input="menu3 = false"
              ></v-date-picker>
            </v-menu>
          </div>

          <div class="flex a-center">
            <div class="as_title"> 고객 응대 메세지</div>
            <v-btn @click="addMsg()" class="add-button">
              <v-icon size="20"> mdi-plus </v-icon>
            </v-btn>
          </div>

        
          <div class="ma-2">
            <div v-for="(msg, index) in replies" :key="index">
                <v-textarea
                  v-model="msg.contents"
                  @focus="selectedReplyIndex = index"
                  @input="replyChange"
                  outlined
                  label=""
                  rows="2"
                  persistent-hint
                  placeholder="접수된 AS내역에 대한 답변을 등록하는 곳입니다. 해당 내용은 고객에게 노출 되어집니다.
AS 진행 시 발생되는 추가 답변은 +버튼을 이용해 추가 후 입력하시면 됩니다."
                  :hint="`${msg.regdate}에 등록완료. ${msg.reguser?.name}님이 작성`"
                ></v-textarea>           
            </div>
            <v-row class="justify-end mr-1">
              <v-btn class="normal-btn mb-3" style="color:white !important; width:70px!important; height:45px !important; border-radius: 30px !important;" @click="replySave()">
                {{ replies[selectedReplyIndex].id ? '응답수정' : '응답등록' }}
              </v-btn>
            </v-row>
          </div>
        </div>

        <div class="action_container" v-show="selectedTab === '조치내역' ">
          <div class="as_title"> 조치내역 </div>
          <v-textarea
            v-model="action_detail"
            @input="actionChange"
            outlined
            label=""
            rows="5"
            placeholder="AS 시 발생된 조치 내역을 입력해주세요. 해당 내용은 CS전용 기록용으로 저장됩니다."
            persistent-hint
            hint=""
          ></v-textarea>

          <div class="flex">
            <div class="as_title"> 소요자재 및 비용 </div>
            <!-- <v-radio-group dense outlined row
                style="margin-top:-3px; height:20px;" 
                id="repair_mode"
                v-model="repair_mode">
                <template v-slot:label>
                </template>
                <v-radio ref="free" label="무상" value="무상" color="#2D3748"/>
                <v-radio ref="paid" label="유상" value="유상" color="#2D3748"/>    
              </v-radio-group> -->
          </div>
   
          <!--유상수리시 Invoice-->
          <div>
            <v-data-table
              :headers="invoice_headers"
              hide-default-footer
              no-data-text="등록된 소요자재가 없습니다."
              :items="invoice"
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(row, index) in items" :key="index">
                  <!-- 품목 선택 -->
                  <td>
                    <v-autocomplete
                      dense
                      outlined
                      hide-details
                      v-model="row.repair_mode"
                      :items="['유상', '무상']"
                      variant="outlined"
                      @change="updateCost(index)"
                    ></v-autocomplete>
                   
                  </td>
                  <td>
                    <v-autocomplete
                      style="max-width:200px !important;"
                      :items="itemOptions"
                      v-model="row.item"
                      item-text="name"
                      item-value="code"
                      dense
                      outlined
                      hide-details
                      label=""
                      @change="updateCost(index)"
                    ></v-autocomplete>
                    <v-text-field
                      v-show="row.item === 'etc'"
                      v-model="row.etc_name"
                      dense
                      outlined
                      hide-details
                      placeholder="기타 항목명을 입력하세요"
                      class="mt-1"
                      :disable="row.item !== 'etc'"
                    ></v-text-field>
                  </td>

                  <!-- 수량 입력 -->
                  <td>
                    <v-text-field
                      color="primary"
                      variant="underlined"
                      v-model.number="row.number"
                      type="number"
                      min="1"
                      dense
                      hide-details
                      @input="updateCost(index)"
                    ></v-text-field>
                  </td>

                  <!-- 비용 (자동계산, 읽기전용) -->
                  <td>
                    <template v-if="row.item === 'etc' && row.repair_mode === '유상'">
                      <v-text-field
                        v-model.number="row.amount"
                        type="number"
                        min="0"
                        dense
                        hide-details
                        placeholder="금액 입력"
                      ></v-text-field>
                    </template>
                    <template v-else>
                      <div>{{ totalPrice(row.amount) }}</div>
                    </template>
                    <!-- <div>{{totalPrice(row.amount)}}</div> -->
                  </td>

                  <td>
                    <v-icon @click="sliceRow(row)" color="black">mdi-delete</v-icon>
                  </td>
                </tr>


                <!-- 합계 -->
                <tr>
                  <td colspan="3" style="text-align: center;"><strong>합계 (VAT포함)</strong></td>
                  <td><strong>{{ totalPrice(totalCost) }}</strong></td>
                </tr>
              </tbody>
            </template>
            </v-data-table>

            <v-row class="justify-end mr-1 mt-1">
              <v-btn @click="invoiceRow()" class="row-btn" style="height:30px; border-radius: 20px; background-color: #e5e5e5;">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </v-row>
           
          </div>

          <v-row class="justify-center mt-5">
            <v-btn @click="saveAction()" class="normal-btn mb-2" style="color:white !important; width:95px!important; height:45px !important; border-radius: 30px !important;"">
              A/S 조치 내역
            </v-btn>
          </v-row>
        </div>

        <div class="complete_container" v-show="selectedTab === '완료처리' ">
          <div class="flex a-center">
            <div class="as_title"> A/S 완료일자</div>
            <v-menu
              v-model="menu4"
              :close-on-content-click="false"
              :nudge-right="10"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable class="shrink mr-2  mt-3"  style="width:180px; height:45px;"
                  id="complete_date" 
                  ref="complete_date" 
                  v-model="complete_date"
                  label=""
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="complete_date"
                @input="menu4 = false"
              ></v-date-picker>
            </v-menu>
          </div>

          <div class="flex">
            <div class="as_title"> 처리 완료 내역 </div>
          </div>

          <div>
            <v-textarea
              v-model="complete_description"
              outlined
              label=""
              rows="5"
              placeholder="최종 AS 수리 내역 및 처리 내역을 입력해주세요. 해당 내용을 입력하시면 처리결과로 고객에게 노출 됩니다."
              persistent-hint
              hint=""
            ></v-textarea>
          </div>
          
          <v-row class="justify-center mt-5" >
            <v-btn @click="saveComplete()" class="normal-btn" style="color:white !important; width:90px!important; height:45px !important; border-radius: 30px !important;">
              A/S완료 처리
            </v-btn>
          </v-row>


        </div>
      </div>

      <div class="line"></div>
      
      <div class="bottom_container">
        
        <div class="status_conatiner">
          <div class="as_title" style="width:80px;">상태변경</div>
          <v-autocomplete dense outlined 
            @change="statusChange()"
            class="shrink mr-2 mt-3"
            style="width:180px; height:45px;"
            id="process_status" 
            v-model="process_status" 
            ref="process_status" 
            label=""
            :items="processStatusItems"
            item-text="name"
            item-value="code"
            :menu-props="{ top: false, offsetY: true }"
            return-object
          />
        </div>

        <div class="flex center notice">
          <div>{{info.chguser.account}}/{{info.chguser.name}}님이 {{ info.chgdate }} 최종 수정</div>
        </div>
        
      </div>
    </div>
  
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

export default {
  name: 'asManage',

  async created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "pigro",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });
    
    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    this.expected_date= dateUtil.format(cdate, "yyyy-MM-dd");
    this.complete_date= dateUtil.format(cdate, "yyyy-MM-dd");
    this.reg_date = dateUtil.format(cdate, "yyyy-MM-dd HH:mm:ss");

    let frdate = new Date(cdate.setDate(cdate.getDate() - 30));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");
    await this.comboFarms();

    this.history();
  },
  watch:{
    status(newValue) {
      this.history();
    },

  },
  computed: {
    totalCost() {
      return this.invoice.reduce((sum, row) => sum + (row.amount || 0), 0);
    },
  },
  mounted() {
    // 페이지별 body 클래스 추가
    document.body.classList.add('history-page-active');
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 페이지 떠날 때 클래스 제거
    document.body.classList.remove('history-page-active');
  },
  data(){
    return {
      selectedTab:'접수응대',

      as_item:{},
      asItems : Common.comboBaseCode("AS"),

      status: '0',
      statusTabs : [
        { label: '전체', value: '0' },
        { label: '미확인', value: '1' },
        { label: '진행중', value: '2' },
        { label: '완료', value: '3' },
        // { label: '보류', value: 'onhold' },
        // { label: '처리불가', value: 'reject' }
      ],
      menu1: false,
      menu2: false,
      fr_date: "",
      to_date: "",

      menu3:false,
      expected_date:"",

      menu4:false,
      complete_date:"",
      reg_date:"",

      farm : {},
      farmItems : [],

      replies: [ ],

      loading:false,
      headers:[
        { text: '접수날짜', value: 'regdate'},
        { text: 'A/S번호', value: 'register_no' },
        { text: 'A/S항목', value: 'division1.description' },
        { text: '고객명', value: 'reguser.name'},
        { text: '상태', value: 'process_status.description', sortable: false },
        { text: ' ', value: ' ', align: 'end', sortable: false },
      ],

      items:[],
      select:null,

      info:{},

      process_status: null,  
      processStatusItems: [
        { name: '미확인', code: 1 },
        { name: '진행중', code: 2 },
        { name: '완료', code: 3 },
      ],
      register_no:'',
      selectedReplyIndex: 0,
      phone:'',

      action_detail:'',
      // repair_mode:'',

      invoice_headers:[
        { text: '유/무상', value: 'repair_mode',width: "120px"},
        { text: '품목명', value: 'item',width: "250px"},
        { text: '수량', value: 'number',width:"75px" },
        { text: '비용', value: 'amount'},
        { text: '', value: ''},

      ],
      itemOptions: [
        { code: 'fan', name: '팬컨트롤러', price: 880000 },
        { code: 'node', name: '센서노드', price: 660000 },
        { code: 'gw', name: '멀티게이트', price: 880000 },
        { code: 'fan_temp', name: '팬컨트롤러 온도', price: 44000 },

        { code: 'dol15_temp', name: 'DOL15(온도)', price: 122100 },
        { code: 'dol115', name: 'DOL115(온도)', price: 125400 },
        { code: 'dol104_10V', name: 'DOL104 습도(0-10V)', price: 299200 },
        { code: 'dol104_3V', name: 'DOL104 습도(0-3V)', price: 299200 },
        { code: 'dol114', name: 'DOL114(복합-온,습)', price: 347600 },
        { code: 'dol119', name: 'DOL119(이산화탄소)', price: 829400 },
        { code: 'dol139', name: 'DOL139(복합-온,습,이)', price: 1004300 },
        { code: 'dol53', name: 'DOL53(암모니아)', price: 2046000 },
        { code: 'dol53_head', name: 'DOL53(헤드)', price: 1900800 },
        { code: 'dol53_filter', name: 'DOL53(먼지필터)', price: 226600 },
        { code: 'dol53_cable', name: 'DOL53(케이블)', price: 168300 },
        { code: 'dol18', name: 'DOL18(기압)', price: 326700 },
        { code: 'dol16', name: 'DOL16 M12(조도)', price: 332200 },
        { code: 'dol15_light', name: 'DOL16(조도)', price: 312400 },
        
        { code: 'fix800', name: 'FIX800', price: 924000 },

        { code: 'sensor', name: '센서교정', price: 200000 },
        { code: 'power', name: '전원불량(SMPS)', price: 30000 },
        { code: 'workfare', name: '장비위치이동', price: 500000 },
        { code: 'out', name: '출장비', price: 200000 },
        { code: 'shipping', name: '택배', price: 5000 },

        { code: 'etc', name: '기타', price: 0 }

      ],
      invoice:[],
      invoice_id:'',

      complete_description:'',

      
    }
  },
  methods:{
    //전체 탭
    onTabChange(value) {
      this.status = value;
    },
    //info 탭
    selectTab(kind) {
      this.selectedTab = kind;
      // this.refresh();
    },
    history() {
      this.loading = true;
      this.$store.commit("resMessage","");

      const params = {
        "process_status": this.status
      };

      // // 날짜가 선택되었을 때만 추가
      if (this.fr_date) {
        params.from = this.fr_date;
      }
      if (this.to_date) {
        params.to = this.to_date + ' 23:59:59';
      }

      // A/S 항목이 선택되었을 때만 추가
      if (this.as_item && this.as_item.code) {
        params.division1 = this.as_item.code;
      }

      // 사업장이 선택되었을 때만 추가
      if (this.farm && this.farm.code) {
        params.farm_cd = this.farm.code;
      }
      // console.log(params)

      Apis.listAsHeads(params ,(res) => {  // 정상처리
        // console.log("res",res.data);
        this.items = res.data;
        this.loading = false;

        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listAsHeads 호출 오류",err);
      }) 
    }, 
    infoAs(value){
      this.select = value;  

      this.register_no = value.register_no;

      Apis.infoAsProcess({
        "register_no": value.register_no
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.info = res.data;
        this.phone = res.data.phone1;

        this.action_detail = res.data.etc2;

        this.complete_date = res.data.etc3;
        this.complete_description = res.data.etc4;

        const code = res.data.process_status.code;
        this.process_status = this.processStatusItems.find(item => item.code === code) || null;

        this.invoice = res.data.invoices[0].contents;
        // this.repair_mode = res.data.invoices[0].etc1;
        this.invoice_id = res.data.invoices[0].id;

        this.replies = res.data.replies || [];
        if (this.replies.length > 0 && this.replies[0].etc1) {
          this.expected_date = this.replies[0].etc1;
        } else {
          this.expected_date = '';
          if (this.replies.length === 0) {
            this.replies.push({
              register_no: '',
              contents: ''
            });
          }
        }

        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("infoAsProcess 호출 오류",err);
      }) 
      // console.log(this.select)

    },
    statusChange(){
      // console.log('바뀜', this.register_no)

      Apis.updateAsHead({
        "register_no":this.register_no,
        "farm_cd":this.farm.code,
        "process_status": parseInt(this.process_status.code)
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.history();

        // console.log('바뀜')
        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("updateAsHead 호출 오류",err);
      }) 
    },
    //완료
    saveComplete(){
      Apis.updateAsHead({
        "register_no":this.register_no,
        "etc3":this.complete_date,
        "etc4":this.complete_description ,
        } ,(res) => {  // 정상처리
          // console.log("res",res);
          this.history();
          // console.log('바뀜')
          this.$store.commit("resMessage",res.message);

        }).catch( (err) => {  // 개별 API 오류 처리 예제
          console.log("updateAsHead 호출 오류",err);
        }) 
      },
    //조치내역 및 영수증
    saveAction(){
      // console.log(this.invoice)
      // console.log(this.complete_date)
      // console.log(this.repair_mode, this.action_detail)
      Apis.updateAsHead({
        "register_no":this.register_no,
        "etc2":this.action_detail ,
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.updateAsInvoice();

        this.history();
        // console.log('바뀜')
        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("updateAsHead 호출 오류",err);
      }) 
    },
    updateAsInvoice(){
      Apis.updateAsInvoice({
        "id":this.invoice_id,
        "contents": this.invoice.map(item => ({
          ...item,
          "reguser": this.$getters.userName,
          "regdate": this.reg_date
        })),
        // "etc1":this.repair_mode,
      } ,(res) => {  // 정상처리
        // console.log("res",res);
        this.history();
        // console.log('바뀜')
        this.$store.commit("resMessage",res.message);

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("updateAsInvoice 호출 오류",err);
      }) 
    },
    //메세지 추가시
    addMsg(){
      this.replies.push({
        contents: '',  
      });
    },
    // sliceMsg(value){
    //   const idx = this.replies.indexOf(value);
    //   if (idx > -1) {
    //     this.replies.splice(idx, 1);
    //   }
    // },
    invoiceRow(){
      this.invoice.push({
        repair_mode:'',
        item: null,
        etc_name:'',
        number: 1,
        amount: 0
      });
    },
    sliceRow(value){
      const idx = this.invoice.indexOf(value);
      if (idx > -1) {
        this.invoice.splice(idx, 1);
      }
    },
    //답변
    replySave(){
      this.replies.forEach(reply => {
        // console.log(reply)
        if(reply.id){
          // console.log('답변수정', reply.id , reply.contents)
          Apis.updateAsReply({
            id: reply.id,
            contents: reply.contents,
            etc1: this.expected_date, 
          }, (res) => {
            if (res.result) {
              // console.log('답변 수정 완료');
              this.history();
            } else {
              alert(res.message);
            }
          }).catch(err => {
            console.log("updateAsReply 호출 오류", err);
          });
        }else{
          // console.log('신규답변', reply.id , reply.contents)
          Apis.insertAsReply({
            register_no: this.register_no,
            contents: reply.contents,
            etc1: this.expected_date,   
          }, (res) => {
            if (res.result) {
              this.sendSMS();
              // console.log('신규답변 저장 완료');
              this.history();
            } else {
              alert(res.message);
            }
          }).catch(err => {
            console.log("updateAsReply 호출 오류", err);
          });
        }
      });
    },
    // 신규 답변이 달릴때만 sms 전송
    sendSMS(){

      Apis.sendSMS({
        receiver : this.phone,
        message : `A/S답변완료 
클라우드팜>고객관리>A/S접수>A/S내역에서 확인바랍니다`,
        // alert_type:"AS",
        farm_cd : this.info.farm.code
      }, (res) => {
        if (res.result) {
          // console.log("SMS전송완료")
        } else {
          alert(res.message);
        }
      }).catch((err) => {
        console.log("sendSMS API 호출 오류", err);
        alert(err);
      });
    },

    //영수증
    updateCost(item){
      const row = this.invoice[item];
      const selected = this.itemOptions.find(i => i.code === row.item);

      // if (selected) {
      //   row.amount = selected.price * row.number;
      // } else {
      //   row.cost = 0;
      // }

      if (!selected) {
        row.amount = 0;
        return;
      }

      const unitPrice = row.repair_mode === '무상' ? 0 : selected.price;
      const quantity = row.number || 0;

      row.amount = unitPrice * quantity;
    },
    totalPrice(value) {
      return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
    },
    statusText(value){
      switch(value) {
        case 1: return '미확인';
        case 2: return '진행중';
        case 3: return '완료'; 
        default: return '알 수 없음';
      }
    },
    itemRowBackground(item) {
      return item.regdate ? 'selected' : '' ;
    },
    async comboFarms() {
      await Apis.comboFarms({
        company_cd: this.company && this.company.code || "",
        new_version : true,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.farmItems = [];

            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company.code, 
              company_name: res.data[i].company.name, 
              code: res.data[i].farm.code,
              name: res.data[i].farm.name,
              biz: res.data[i].farm.biz
              });
            }  
            // if (this.farmItems.length > 0) {
            //   this.farm = this.farmItems[0];
            // }
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
        }
      ) 
    },
    ingStatus(){
      Apis.updateAsHead({
        "register_no": this.register_no,
        "farm_cd": this.farm.code,
        "process_status": 2
      }, (res) => {
        if (res.result) {
          // this.history();
          
          this.process_status = this.processStatusItems.find(item => item.code === 2);
          
          this.$store.commit("resMessage", "상태가 진행중으로 변경되었습니다.");
        }
      }).catch((err) => {
        console.log("updateAsHead 호출 오류", err);
      });
    },
    dateChange(){
      this.ingStatus();
    },
    replyChange(){
      this.ingStatus();
    },
    actionChange(){
      this.statusChange();
    }
  }
}
</script>

<style lang="scss">
@import './style/as.scss';
::v-deep .sensor_name{
  // font-size:0.8rem !important;
  background-color:red !important; 
}
.history-page {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;

  
  .history__layout{
    // height: 65vh;
    background-color: white;
  }
  ::v-deep .table {
    overflow: scroll;
  }
  .v-main__wrap, .v-tabs-bar__content{
    background-color: #F5F7FA !important;
  }
  .flex{
    display:flex;
    width:100%;
    margin:10px;
  }
  .filter_container{
    width:55%;
    /* background-color:red; */
    margin-right:5px;
    padding:10px;
  }
  .manage_container{
    width:35%;
    padding:10px;
  }
  .filter_content{
    margin-top:5px;
    background-color: #f0f0f0;
    padding:5px 10px ;
    border-radius: 15px;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .manage_container{
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius:20px;
    padding:20px;
  }
  .tab_container{
    display:flex;
    align-items: center;
    background-color: #F3F3F3;
    border-radius: 30px;
  }
  .tab_content{
    display: inline-flex;
    padding:5px;
    border-radius: 5px;
    overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
    height: 55px;
  }
  .tab_container,
  .title_container,
  .bottom_container {
    flex-shrink: 0; /* 줄어들지 않음 */
  }
  .tab {
    flex: 1;
    width:100vw;
    border-radius: 30px;
    border: none;
    /* background-color: #e7e7e7; */
    /* color: ㅠㅣ;  */
    font-size: 15px !important;
    cursor: pointer;
    transition: all 0.5s ease;
  }
  .tab.active {
    background-color: white; 
    color: #2D3748;
    font-weight:600;
    font-size:20px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2); 
  }
  .serach_btn{
    width: 40px !important;
    height: 40px !important;
    border-radius: 50% !important;
    min-width: unset !important;
    background-color:#E3F2FD !important;
    /* padding:5px !important; */
    /* border-radius: 50% !important;  */
    /* box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25); */
    margin-top:5px;
  }
  tr.v-data-table__selected {
    background: #edfcf0 !important;
  }
  .selected {
    background-color: #F1F1F1 !important;
  }
  .table_tr{
    height:42px;
  }
  .table_tr td{
    font-size:15px !important;
    letter-spacing: -1px;
  }
  .flex{
    display:flex;
  }
  .center{
    justify-content: center;
  }
  .a-center{
    align-items: center;
  }
  .normal-btn{
    color:white;
    background-color: #2D3748 !important;
    border-radius: 30px;
    height:45px !important;
    font-size:15px !important;
    letter-spacing: -0.75px;
  }
  .notice{
    font-size:15px;
    letter-spacing: -1px;
    color:#ababab;
  }
  .del-btn{
    height:50px !important;
    width:30px !important;
    margin-top:-20px;
    margin-left:10px;
    margin-right:10px;
    background-color: #ababab;
    border-radius: 10px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  }
}
</style>